import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

interface completedLearningProps {
  pageNumber: number;
  pageSize: number;
  countAndSkills?: boolean;
}

export const CompletedLearningApi = createApi({
  reducerPath: "completedLearningApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getCompletedLearningApi: builder.query({
      query: ({
        pageNumber,
        pageSize,
        requiredQuery = `timestamp
                    data {
                      searchResult {
                        id
                        externalownerlist
                        title
                        brandingurls {
                          promo
                          thumbnail
                          banner
                        }
                        branding {
                          promo
                          thumbnail
                          banner
                        }
                        stakeholder{
                          owner
                          observer
                        }
                        language
                        launchdate
                        createdby
                        shortdescription
                        expirydate
                        episodenumber
                        episodecount
                        longdescription
                        prerequisite
                        createdat
                        status
                        publishedat
                        sourcename
                        sourcetype
                        weblink
                        artifacttype
                        skills {
                          type
                          skillid
                          parentskill
                          preferredskillname {
                            en_UK
                            en_US
                          }
                        }
                        searchtags {
                          defaultTag
                        }
                        joblevel
                        privateusergroup
                        startdate
                        proficiency
                        mode
                        function
                        isblocking
                        publishedby
                        maxcapacity
                        visibility
                        difficultylevel
                        registrationcost {
                          amount
                          currency
                        }
                        templateid
                        enddate
                        eventtype
                        pageno
                        duration
                        artifactid
                      }
                      pageNumber
                      pageSize
                      totalCount
                    }
                    error`
      }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            completedLearning(
              pageNumber: ${pageNumber}
              pageSize: ${pageSize}
              sortKey: "_score"
              sortOrder: "ASC"
              relevance: false
            ) {
              ${requiredQuery}
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ queryArgs }) => {
        const { requiredQuery } = queryArgs;
        return JSON.stringify({ requiredQuery });
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.pageNumber > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.completedLearning.data.searchResult,
            ...responseData.completedLearning.data.searchResult
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            completedLearning: {
              ...responseData.completedLearning,
              data: {
                ...responseData.completedLearning.data,
                searchResult: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useGetCompletedLearningApiQuery,
  useLazyGetCompletedLearningApiQuery
} = CompletedLearningApi;
